<template>
    <router-link :to="{name: 'news-detail', params: {id: data._id}}">
        <div class="bg-[#fafafa] p-3 rounded-md mb-3">
            <div class="mb-3">
                <h2 class="text-base">{{data.TITLE}}</h2>
            </div>
            <div class="flex text-gray-500 items-center gap-1">
                <CalendarIcon class="w-4 h-4"/>
                <div>
                    <p class="mb-0 text-xs">
                        {{
                            new Date(data.createdAt).toLocaleDateString("th-TH", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            })
                        }}
                    </p>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script setup>
const props = defineProps({
    data: Object
})

</script>

<style>

</style>